import React from "react";
import { styled } from "@mui/material/styles";
const componentStyles = () => ({
  creditCardHolder: {
    width: 50,
    height: 32,
    border: "1px solid #1c355e",
    borderRadius: 4,
    backgroundColor: "#fff"
  },
  creditCard: {
    paddingTop: 2,
    paddingLeft: 2,
    width: 46,
    height: 28
  }
});
const StyledRoot = styled("div")(({
  theme
}) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce((acc, [className, style]) => ({
    ...acc,
    [`& .${className}, &.${className}`]: style
  }), {})
}));
export const CreditCardSwitch = cardType => {
  return <StyledRoot>
    <div className={"creditCardHolder"}>
      {{
        MasterCard: <img className={"creditCard"} src={"./src/_images/CreditCards/Mastercard_Logo.png"} />,
        Visa: <img className={"creditCard"} src={"./src/_images/CreditCards/Visa_Logo.png"} />,
        Discover: <img className={"creditCard"} src={"./src/_images/CreditCards/Discover_Logo.png"} />,
        AmericanExpress: <img className={"creditCard"} src={"./src/_images/CreditCards/AmericanExpress_Logo.png"} />
      }[cardType.cardType]}
    </div>
  
    </StyledRoot>;
};
